export const Edit = () => {
  return (
    <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.15659 2.68683H2.59035C2.16857 2.68683 1.76405 2.85438 1.4658 3.15263C1.16755 3.45088 1 3.85539 1 4.27718V15.4097C1 15.8314 1.16755 16.236 1.4658 16.5342C1.76405 16.8324 2.16857 17 2.59035 17H13.7228C14.1446 17 14.5491 16.8324 14.8474 16.5342C15.1456 16.236 15.3132 15.8314 15.3132 15.4097V9.84342"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1208 1.49406C14.4372 1.17772 14.8662 1 15.3136 1C15.761 1 16.19 1.17772 16.5064 1.49406C16.8227 1.8104 17.0004 2.23945 17.0004 2.68682C17.0004 3.1342 16.8227 3.56325 16.5064 3.87959L8.95219 11.4338L5.77148 12.2289L6.56666 9.04824L14.1208 1.49406Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
